var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useState } from 'react';
import { useRecoilState } from 'recoil';
import { useRequest } from '../../hooks/useRequest';
import { generateQueryParams, dateFilterValuesGenerator } from '../../utils';
import { chatSessionsAtom, sessionsIsLoadingAtom, chatConversationsAtom, conversationsIsLoadingAtom } from '../store';
export var useChatHistory = function () {
    var request = useRequest();
    var _a = useRecoilState(chatSessionsAtom), sessions = _a[0], setSessions = _a[1];
    var _b = useRecoilState(sessionsIsLoadingAtom), sessionsIsLoading = _b[0], setSessionsIsLoading = _b[1];
    var _c = useRecoilState(chatConversationsAtom), conversations = _c[0], setConversations = _c[1];
    var _d = useRecoilState(conversationsIsLoadingAtom), conversationsIsLoading = _d[0], setConversationsIsLoading = _d[1];
    var _e = useState(0), totalSessionCount = _e[0], setTotalSessionCount = _e[1];
    var getSessions = function (pageNumber, pageSize, filterData, onSuccess) {
        var _a;
        if (pageNumber === void 0) { pageNumber = 1; }
        if (pageSize === void 0) { pageSize = 10; }
        if (filterData === void 0) { filterData = {}; }
        setSessionsIsLoading(true);
        var query = generateQueryParams(__assign(__assign({ pageNumber: pageNumber, pageSize: pageSize }, dateFilterValuesGenerator(filterData.date)), { flowId: filterData.flowId || undefined, isTest: (_a = filterData.isTest) !== null && _a !== void 0 ? _a : undefined }));
        request.get("/history/chat/sessions?".concat(query))
            .then(function (_a) {
            var data = _a.data;
            var newSessions = data.sessions, totalCount = data.totalCount;
            setTotalSessionCount(totalCount);
            // Append new sessions if page > 1
            setSessions(function (prevSessions) { return pageNumber === 1 ? newSessions : __spreadArray(__spreadArray([], prevSessions || [], true), newSessions, true); });
            if (onSuccess)
                onSuccess();
        })
            .catch(console.error)
            .finally(function () { return setSessionsIsLoading(false); });
    };
    var getConversationsBySessionId = function (sessionId) {
        setConversationsIsLoading(true);
        request
            .get("/history/chat/conversationsBySessionId/".concat(sessionId))
            .then(function (_a) {
            var data = _a.data;
            var conversationItems = data;
            setConversations(conversationItems);
        })
            .catch(console.error)
            .finally(function () { return setConversationsIsLoading(false); });
    };
    var getSessionById = function (sessionId) { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, request.get("/history/chat/sessions/".concat(sessionId))];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response.data];
                case 2:
                    error_1 = _a.sent();
                    console.error("Error fetching session by ID:", error_1);
                    return [2 /*return*/, null];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var markSessionAsRead = function (sessionId) {
        if (!sessionId) {
            console.error("Session ID is null or undefined");
            return;
        }
        request.put("/history/chat/sessions/".concat(sessionId, "/read"))
            .catch(console.error);
    };
    return {
        sessions: sessions,
        sessionsIsLoading: sessionsIsLoading,
        totalSessionCount: totalSessionCount,
        conversations: conversations,
        conversationsIsLoading: conversationsIsLoading,
        getSessionById: getSessionById,
        getSessions: getSessions,
        getConversationsBySessionId: getConversationsBySessionId,
        markSessionAsRead: markSessionAsRead,
    };
};
